export function* waitForFetchEnvironments() {
  yield true;
}
